import axios, { AxiosResponse } from 'axios';
import { apiClient } from './endpoints';

export interface SystemConfig {
    _id: string;
    key: string;
    value: any;
    description?: string;
    group?: string;
    updatedAt?: string;
    createdAt?: string;
}

export interface SystemConfigsResponse {
    message: string;
    data: SystemConfig[];
}

export interface SystemConfigResponse {
    message: string;
    data: SystemConfig;
}

export interface SystemConfigQueries {
    group?: string;
    key?: string;
}

export const getAllSystemConfigs = async (queries?: SystemConfigQueries): Promise<SystemConfigsResponse> => {
    try {
        const response: AxiosResponse<SystemConfigsResponse> = await apiClient.get('/system-configs', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

export const getSystemConfigByKey = async (key: string): Promise<SystemConfigResponse> => {
    try {
        const response: AxiosResponse<SystemConfigResponse> = await apiClient.get(`/system-configs/${key}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

export interface UpdateSystemConfigBody {
    value?: any;
    description?: string;
}

export const updateSystemConfigById = async (id: string, data: UpdateSystemConfigBody): Promise<SystemConfigResponse> => {
    try {
        const response: AxiosResponse<SystemConfigResponse> = await apiClient.patch(`/system-configs/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};
